import { RootState } from '@/store/types'
import { Module } from 'vuex'
import { PronosticoHidricoState } from '@/store/modules/pronostico-hidrico/types'
import { getters } from '@/store/modules/pronostico-hidrico/getters'
import { actions } from '@/store/modules/pronostico-hidrico/actions'
import { mutations } from '@/store/modules/pronostico-hidrico/mutations'

export const state: PronosticoHidricoState = {
  pronostico: [],
  etiqueta_list: [],
  link_descarga: false,
  estacion_id: '',
  isLoaded: false,
  error: { state: false }
}

const namespaced: boolean = true

export const pronosticoHidrico: Module<PronosticoHidricoState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
